import { all, call, put, takeLatest } from "redux-saga/effects";
import { fetchSystemIDSuccess, fetchSystemIDFailure } from "./actions";
import { FETCH_DEVICE_SYSTEM_ID_REQUEST } from "./actions.type";
import { DeviceInfoProps, getDeviceType, getDevicesInfo } from "app/shared/util/devices-info";

function* fetchDeviceIDSaga() {
  try {
    const deviceInfo: DeviceInfoProps = yield call(getDevicesInfo);
    const deviceType: string = yield call(getDeviceType);
    deviceInfo.deviceType = deviceType;

    yield put(fetchSystemIDSuccess(deviceInfo));
  } catch (e: any) {
    yield put(fetchSystemIDFailure());
  }
}

function* deviceInfoSaga() {
  yield all([takeLatest(FETCH_DEVICE_SYSTEM_ID_REQUEST, fetchDeviceIDSaga)]);
}

export default deviceInfoSaga;
